import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Third-party library imports.
import React from 'react';
import PropTypes from 'prop-types';
// Tekion library imports.
import Uploader from '@tekion/tekion-components/src/molecules/uploader';
import Button from '@tekion/tekion-components/src/atoms/Button';
import Modal from '@tekion/tekion-components/src/molecules/Modal';
import { EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import { FILE_MODAL_SEC_BUTTON_TXT, FILE_UPLOAD_BUTTON_TXT, FILE_UPLOAD_STATUS, MODAL_TITLE } from './UploadAsModal.constants';
import { isAttachmentDiff } from '../../utils/helper.fileattachment';
import { NO_OP } from '../../constants/Constants';
import './UploadAsModal.scss';
import TokenManager from '../../utils/TokenManager';
class UploadAsModal extends React.Component {
  constructor(props) {
    super(props);
    this.setUploadInProgress = uploadInProgress => {
      this.setState({
        uploadInProgress
      });
    };
    this.addAttachment = file => {
      const {
        onAddAttachment
      } = this.props;
      onAddAttachment(file);
    };
    this.onRemoveAttachment = file => {
      const {
        onRemoveAttachment
      } = this.props;
      onRemoveAttachment(file);
    };
    this.onAttachmentChange = info => {
      const {
        file
      } = info;
      if (!file) {
        return;
      }
      const {
        status
      } = file;
      switch (status) {
        case FILE_UPLOAD_STATUS.UPLOADING:
          this.setUploadInProgress(true);
          break;
        case FILE_UPLOAD_STATUS.DONE:
          this.setUploadInProgress(false);
          this.addAttachment(file);
          break;
        case FILE_UPLOAD_STATUS.REMOVED:
          this.onRemoveAttachment(file);
          break;
        default:
          break;
      }
    };
    this.getHeaders = () => {
      const {
        headers
      } = this.props;
      return _objectSpread({
        'tap-api-token': TokenManager.getItem(TokenManager.accessTokenKey)
      }, headers);
    };
    const {
      files
    } = props;
    this.state = {
      files,
      uploadInProgress: false
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      files
    } = nextProps;
    const {
      files: prevFiles
    } = prevState;
    const obj = {};
    const diff = isAttachmentDiff(prevFiles, files);
    if (diff) {
      obj.files = Object.assign([], files);
    }
    return obj;
  }
  render() {
    const {
      showModal,
      onCancel,
      actionURL,
      title,
      allowMultiple
    } = this.props;
    const {
      files,
      uploadInProgress
    } = this.state;
    return /*#__PURE__*/React.createElement(Modal, {
      centered: true,
      destroyOnClose: true,
      hideSubmit: true,
      loading: uploadInProgress,
      secondaryBtnText: __(FILE_MODAL_SEC_BUTTON_TXT),
      title: __(title),
      visible: showModal,
      width: "80rem",
      zIndex: 9999,
      onCancel: onCancel
    }, /*#__PURE__*/React.createElement(Uploader, {
      action: actionURL,
      defaultFileList: files,
      headers: this.getHeaders(),
      multiple: allowMultiple,
      onChange: this.onAttachmentChange
    }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement("span", {
      className: "icon-upload upload-as-modal-icon"
    }), " ", __(FILE_UPLOAD_BUTTON_TXT))));
  }
}
UploadAsModal.propTypes = {
  actionURL: PropTypes.string,
  allowMultiple: PropTypes.bool,
  files: PropTypes.array,
  headers: PropTypes.object,
  onAddAttachment: PropTypes.func,
  onCancel: PropTypes.func,
  onRemoveAttachment: PropTypes.func,
  showModal: PropTypes.bool,
  title: PropTypes.string
};
UploadAsModal.defaultProps = {
  actionURL: EMPTY_STRING,
  allowMultiple: true,
  files: EMPTY_ARRAY,
  headers: EMPTY_OBJECT,
  onAddAttachment: NO_OP,
  onCancel: NO_OP,
  onRemoveAttachment: NO_OP,
  showModal: false,
  title: __(MODAL_TITLE)
};
export default UploadAsModal;